import React from "react";

const About = () => {
  return (
    <>
      <h1 style={{ textShadow: "none" }}>Takarakuji</h1>
      <br />
      <img src="https://thehill.com/wp-content/uploads/sites/2/2022/12/ScratchTicketsAP20177609757636.jpg?strip=1&w=640" alt="us" />
      <br />
      <br />
      <img src="https://lh5.googleusercontent.com/p/AF1QipMBzEJRvfjnLy2nMcyC2FfkZWAW2SFbek0Gjsul=s1193-k-no" alt="store" />
      <br />
      <br />
      <img src="https://i.ytimg.com/vi/JDAEQt8Fbxo/maxresdefault.jpg" alt="scratchoff" />
    </>

  );
};

export default About;